// Theme renderContents leaves the drawer blank when the cart was empty at page load.
// After every successful add (event fired by rodentlab-cart-fallback-v2.js), re-render the drawer from the section API and open it.
(function () {
  function refreshDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return Promise.resolve(null);
    return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var fresh = new DOMParser().parseFromString(s['cart-drawer'] || '', 'text/html').querySelector('cart-drawer');
        if (!fresh) return drawer;
        var cur = drawer.querySelector('.drawer__inner');
        var nxt = fresh.querySelector('.drawer__inner');
        if (cur && nxt) cur.innerHTML = nxt.innerHTML;
        drawer.classList.toggle('is-empty', fresh.classList.contains('is-empty'));
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && s['cart-icon-bubble']) {
          var b = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (b) bubble.innerHTML = b.innerHTML;
        }
        return drawer;
      });
  }
  document.addEventListener('rodentlab:cart-added', function (e) {
    if (e.detail && e.detail.viaBuyNow) return;
    setTimeout(function () {
      refreshDrawer().then(function (drawer) {
        if (drawer && !drawer.classList.contains('active') && typeof drawer.open === 'function') drawer.open();
      }).catch(function () {});
    }, 80);
  });
})();
